import React from 'react';
// @mui
import { TableCell } from '@mui/material';
import i18n from '../../i18n';
import { extractValues } from '../../utils/formatName';
import { AppDataContext } from '../../context/Context';

const styles = {
    controllerCell: {
        backgroundColor: '#F4F6F8',
        fontWeight: 'bold'
    }
};

export default class GridSelectCell extends React.Component {
    static contextType = AppDataContext;
    render() {
        const { field } = this.props;
        let value = this.props.value;
        let show = this.props.field.show;
        let translate = this.props.field.translate;
        let needStyle = this.props.field.needStyle;
        let displayValue = '';

        if (value) {
            if (show && typeof show === 'string') {
                let parts = show.split('+');
                displayValue = extractValues(value, parts);
                if (value.secondaryName) {
                    displayValue = value.secondaryName + ' - ' + displayValue;
                }
            } else {
                displayValue = value.id;
            }
        }
        const translatedValue =
            displayValue && translate
                ? i18n.t(`${translate}.${displayValue}`)
                : displayValue;
        const baseStyle = this.props.styles;
        return (
            <TableCell
                key={field.id}
                align="left"
                sx={{ ...(needStyle ? styles.controllerCell : {}), ...baseStyle }}
            >
                {translatedValue}
            </TableCell>
        );
    }
}
